import { getGeoPositionsByStrings } from "./getGeoPositionsByStrings";
export const getGeoPositionByString = (text) => {
    const { coordinates, errors, } = getGeoPositionsByStrings([text]);
    return {
        coordinate: coordinates.pop() || null,
        error: errors.pop() || null,
    };
};
